/*
 * biobio-pdp-offer.js: Web Component <pdp-offer>
 *
 * Widget de oferta multi-unidade da PDP-mestre. Dirige o markup de
 * snippets/biobio-pdp-offer.liquid. Contrato completo no HANDOFF-pdp-master.md
 * secao "Contrato de markup/eventos".
 *
 * Reusa patterns de biobio-bundle-selector-fb.js (estados de CTA + N line items
 * + updateCartSummaries) e biobio-bundle-selector-trio.js (fallback de submit em
 * page template), SEM a etapa de cupom (Yampi ignora cupom Shopify, Plan B-C).
 *
 * CRITERIO DE ACEITE DURO: add-to-cart real via POST /cart/add.js + abrir o
 * cart drawer, com N line items SEPARADOS (property _unidade por unidade,
 * exigencia do ERP). NUNCA submit nativo, NUNCA pulo pro checkout Yampi.
 * Exceção: degrau com kit (PDPs VIP, spec 2026-10-23) vai como UMA linha, a
 * variante do produto-kit casada pelo tom de cada posição, com property _oferta.
 *
 * Eventos: emite pdp-offer:tier-changed {quantidade, selected} e
 * pdp-offer:variant-changed {variantId, selected}; escuta tone-finder:resolved
 * {variantIds} pra pre-selecionar a unidade 1 do tier ativo, exceto quando o
 * finder esta em modo aplicar (gaveta, data-result-mode="apply"): ali so o
 * "Usar este tom" aplica.
 */
(function () {
  if (window.customElements && customElements.get('pdp-offer')) return;

  const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  const money = function (cents) { return BRL.format((cents || 0) / 100); };
  const cssEscape = function (s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  };
  // Trava do degrau sem caminho de compra: a mesma copy da rotina (biobio-pdp-complementares).
  const TEXTO_INDISPONIVEL = 'Combinação indisponível no momento';

  class PdpOffer extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;

      this.tiers = this.parseJSON('[data-pdp-tiers]', []);
      this.variants = this.parseJSON('[data-pdp-product-variants]', []);
      // id da variante -> descricao da cor (custom.descricao_cor); so existe no HTML quando alguma variante tem texto.
      this.corDesc = this.parseJSON('[data-pdp-cor-desc]', {});
      this.productPrice = parseInt(this.dataset.productPrice, 10) || 0;
      this.productCompare = parseInt(this.dataset.productCompare, 10) || 0;
      this.designMode = this.dataset.designMode === 'true';
      this.hasVariant = this.variants.length > 1;
      this.mode = this.tiers.length <= 1 ? 'direct' : 'cards';

      this.variantById = {};
      this.variants.forEach(function (v) { this.variantById[v.id] = v; }, this);
      this.defaultVariantId = this.variants.length ? this.variants[0].id : null;

      this.form = this.querySelector('.pdp-offer__form');
      this.addBtn = this.querySelector('[data-pdp-add-to-cart]');
      this.summaryEl = this.querySelector('[data-pdp-summary]');
      this.totalEl = this.querySelector('[data-pdp-total]');
      this.compareEl = this.querySelector('[data-pdp-compare]');
      this.econEl = this.querySelector('[data-pdp-econ]');
      this.notaEl = this.querySelector('[data-pdp-nota]');
      this.pixEl = this.querySelector('[data-pdp-pix]');
      this.pixValorEl = this.querySelector('[data-pdp-pix-valor]');
      this.unavailableEl = this.querySelector('[data-pdp-unavailable]');
      this.aviseEl = this.querySelector('[data-pdp-avise]');
      this.aviseDialog = this.querySelector('[data-pdp-avise-dialog]');
      this.aviseAlvoEl = this.querySelector('[data-pdp-avise-alvo]');
      this.aviseProdutoNome = this.aviseAlvoEl ? this.aviseAlvoEl.textContent.trim() : '';
      this.stepperEl = this.querySelector('[data-pdp-stepper]');
      this.aviseTagsEl = this.querySelector('[data-pdp-avise-tags]');
      // Termos fixos do SSR (geral + por produto); o do tom entra em runtime.
      this.aviseTagsBase = this.aviseTagsEl
        ? this.aviseTagsEl.value.split(',').slice(0, 2).join(',').trim()
        : '';
      // Slug de cada tom, gerado pelo `handleize` do Liquid no SSR.
      this.aviseSlugs = this.parseJSON('[data-pdp-avise-slugs]', {});
      // copy canonica de indisponibilidade (SSR), pra reescrever sem herdar
      // texto stale de erro de add-to-cart no mesmo elemento.
      this.unavailableText = this.unavailableEl ? this.unavailableEl.textContent.trim() : '';

      this.qty = 1; // modo direto

      if (this.mode === 'cards') this.bindCards(signal);
      else this.bindDirect(signal);

      if (this.addBtn) {
        this.addBtn.addEventListener('click', this.handleSubmit.bind(this), { signal: signal });
      }
      const aviseAbrir = this.querySelector('[data-pdp-avise-open]');
      if (aviseAbrir) {
        aviseAbrir.addEventListener('click', this.abrirAvise.bind(this), { signal: signal });
      }
      const aviseForm = this.aviseDialog ? this.aviseDialog.querySelector('form') : null;
      if (aviseForm) {
        /*
         * Submit NATIVO de proposito, sem fetch. O POST via fetch pra /contact
         * esbarra na protecao anti-bot do Shopify em navegador real (403
         * intermitente): o catch mostrava "nao deu pra enviar" um instante
         * antes do envio acontecer pelo caminho nativo, um erro falso na
         * frente de um fluxo que salva (2x confirmado no admin em 04/08).
         * O nativo tambem resolve o hCaptcha quando o Shopify pede, e a volta
         * (?customer_posted=true) reabre o modal ja confirmado. Aqui so
         * sincronizamos as tags antes de ir (Enter no campo inclusive).
         */
        const enviar = this.aviseDialog.querySelector('[data-pdp-avise-send]');
        /*
         * O preparo (tags + marca de sessao) roda no evento 'submit', que e o
         * unico ponto por onde os DOIS caminhos passam: clique no botao (via
         * requestSubmit) e ENTER no campo (submissao implicita). Marcar so no
         * clique deixava o envio por Enter salvar as tags e a volta NAO abrir a
         * confirmacao, porque o gate bloqueava.
         */
        aviseForm.addEventListener('submit', function () {
          this.prepararEnvioAvise();
          if (enviar) {
            enviar.disabled = true;
            enviar.textContent = 'Enviando...';
          }
        }.bind(this), { signal: signal });

        if (enviar) {
          enviar.addEventListener('click', function () {
            // validacao ANTES de qualquer estado: email invalido nao pode deixar
            // o botao morto com o balao de validacao na tela.
            if (typeof aviseForm.reportValidity === 'function' && !aviseForm.reportValidity()) return;
            if (typeof aviseForm.requestSubmit === 'function') {
              aviseForm.requestSubmit(); // dispara 'submit' -> prepararEnvioAvise
            } else {
              // form.submit() NAO dispara o evento 'submit': prepara na mao.
              this.prepararEnvioAvise();
              enviar.disabled = true;
              enviar.textContent = 'Enviando...';
              aviseForm.submit();
            }
          }.bind(this), { signal: signal });
        }
      }
      if (this.aviseDialog) {
        const fechar = this.aviseDialog.querySelector('[data-pdp-avise-close]');
        if (fechar) {
          fechar.addEventListener('click', function () { this.aviseDialog.close(); }.bind(this), { signal: signal });
        }
        // Clique no ::backdrop chega no proprio <dialog>, nunca num filho.
        this.aviseDialog.addEventListener('click', function (e) {
          if (e.target === this.aviseDialog) this.aviseDialog.close();
        }.bind(this), { signal: signal });
      }
      document.addEventListener('tone-finder:resolved', this.onToneResolved.bind(this), { signal: signal });

      this.computeAll();
      this.updateState();

      /*
       * Volta do submit NATIVO (JS em cache antigo na hora do envio, ou sem JS):
       * o POST em /contact recarrega a pagina com ?customer_posted=true e a
       * confirmacao se perderia na recarga. Reabrimos o dialog, que o Liquid ja
       * renderizou no estado de sucesso (form.posted_successfully?), e limpamos
       * o param pra um F5 nao reabrir o modal.
       */
      // Volta com erro do servidor (email invalido que passou na validacao do
      // navegador): o {% form %} renderiza .errors dentro do dialog, que estaria
      // fechado; reabrimos pra cliente VER o erro em vez de um reload mudo.
      if (this.aviseDialog && this.aviseDialog.querySelector('.pdp-avise__form .errors') &&
          typeof this.aviseDialog.showModal === 'function' && !this.aviseDialog.open) {
        this.aviseDialog.showModal();
        this.desfazerScrollDoContactForm();
      }
      let avisePendente = true;
      try {
        avisePendente = sessionStorage.getItem('bb-avise-pendente') !== null;
        if (avisePendente) sessionStorage.removeItem('bb-avise-pendente');
      } catch (err) { /* sem sessionStorage, comporta como antes */ }
      if (avisePendente &&
          /[?&]customer_posted=true/.test(location.search) &&
          this.aviseDialog && this.aviseDialog.querySelector('[data-pdp-avise-posted]')) {
        if (typeof this.aviseDialog.showModal === 'function') this.aviseDialog.showModal();
        this.mostrarAviseSucesso();
        this.desfazerScrollDoContactForm();
        try {
          const url = new URL(location.href);
          url.searchParams.delete('customer_posted');
          history.replaceState(null, '', url.pathname + url.search);
        } catch (err) { /* URL API indisponivel: o param fica, sem quebrar nada */ }
      }
    }

    /*
     * A volta do POST vem com #contact_form na URL. O form do MODAL tem esse id,
     * mas dentro de dialog fechado (display:none) ele nao e alcancavel, entao o
     * navegador ancora no OUTRO #contact_form da pagina: a newsletter do RODAPE.
     * Resultado, pagina rolada pro fim por baixo do modal. Volta pro topo e tira
     * o hash pra um F5 nao repetir a rolagem.
     */
    desfazerScrollDoContactForm() {
      if (location.hash !== '#contact_form') return;
      const topo = function () { window.scrollTo(0, 0); };
      topo();
      /*
       * O navegador tenta ancorar no fragment DE NOVO no evento load, usando o
       * fragment da navegacao (limpar o location.hash nao cancela essa segunda
       * tentativa). Medido: scrollY voltava a ~3160 depois do nosso scrollTo.
       * Repetimos no load e um pouco depois dele pra cobrir os dois momentos.
       */
      window.addEventListener('load', function () {
        topo();
        setTimeout(topo, 150);
      }, { once: true });
      if (document.readyState === 'complete') setTimeout(topo, 150);
      try {
        history.replaceState(null, '', location.pathname + location.search);
      } catch (err) { /* sem replaceState o scrollTo ja resolveu o visivel */ }
    }

    marcarAviseEnviado() {
      const abrir = this.querySelector('[data-pdp-avise-open]');
      if (abrir) {
        abrir.textContent = 'Aviso pedido';
        abrir.disabled = true;
      }
    }

    /*
     * Estado de sucesso do modal, usado pelos DOIS caminhos (fetch e volta do
     * POST nativo). O X some porque ele e absoluto no canto e ficava POR CIMA
     * do texto (visto no teste do Breno); sem acao restante pra cliente, o
     * modal se fecha sozinho. O botao externo 'Aviso pedido' fica como registro
     * persistente depois que ele fecha.
     */
    mostrarAviseSucesso() {
      if (!this.aviseDialog) return;
      const corpo = this.aviseDialog.querySelector('.pdp-avise__form');
      if (corpo && !corpo.querySelector('[data-pdp-avise-posted]')) {
        corpo.innerHTML =
          '<p class="pdp-avise__ok" role="status">Pronto. A gente te avisa por e-mail assim que voltar.</p>';
      }
      const fechar = this.aviseDialog.querySelector('[data-pdp-avise-close]');
      if (fechar) fechar.hidden = true;
      this.marcarAviseEnviado();
      clearTimeout(this._aviseTimer);
      this._aviseTimer = setTimeout(
        function () {
          if (this.aviseDialog.open) this.aviseDialog.close();
        }.bind(this),
        5000
      );
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
    }

    parseJSON(sel, fallback) {
      const el = this.querySelector(sel);
      if (!el) return fallback;
      try {
        const parsed = JSON.parse(el.textContent);
        return parsed == null ? fallback : parsed;
      } catch (err) {
        if (this.designMode) console.warn('[pdp-offer] JSON invalido em ' + sel, err);
        return fallback;
      }
    }

    /* ---------- bind: modo cards (2/3 tiers) ---------- */
    bindCards(signal) {
      this.querySelectorAll('input[name="pdp-tier"]').forEach(function (radio) {
        radio.addEventListener('change', this.onTierChange.bind(this), { signal: signal });
      }, this);
      this.bindSwatches(signal);
    }

    /* ---------- bind: modo direto (1 tier) ---------- */
    bindDirect(signal) {
      const stepper = this.querySelector('[data-pdp-stepper]');
      if (stepper) {
        stepper.querySelectorAll('[data-step]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            const delta = parseInt(btn.dataset.step, 10) || 0;
            this.qty = Math.max(1, this.qty + delta);
            const valEl = this.querySelector('[data-step-value]');
            if (valEl) valEl.textContent = String(this.qty);
            this.computeAll();
            this.updateState();
          }.bind(this), { signal: signal });
        }, this);
      }
      this.bindSwatches(signal);
    }

    // Os radios de swatch ficam DENTRO do form do tema (.product-form--main); o
    // 'change' nativo do toggle nao chega ate aqui de forma confiavel (o JS do
    // tema interfere). Entao: mouse via 'click' no LABEL (confiavel, o tema nao
    // mexe nisso) + teclado via 'change' do radio (setas). onSwatch tem guard de
    // re-selecao, entao disparar 2x no mesmo swatch nao duplica o evento. O swatch-clicked
    // sai so quando event.target !== input (um por gesto, sem o click sintetico do radio).
    bindSwatches(signal) {
      this.querySelectorAll('.pdp-offer__swatches .swatch').forEach(function (sw) {
        const input = sw.querySelector('input[type="radio"]');
        if (!input) return;
        sw.addEventListener('click', function (ev) {
          // Bolinha riscada: o ouvinte de .swatch do theme.js (no document) marcaria o radio
          // mesmo desabilitado e a compra leria a variante esgotada. Corta o click aqui.
          if (input.disabled || sw.classList.contains('swatch--disabled')) {
            if (ev && ev.preventDefault) ev.preventDefault();
            if (ev && ev.stopPropagation) ev.stopPropagation();
            return;
          }
          // Todo toque no tom sai como evento, inclusive no que ja esta escolhido (onSwatch
          // deduplica e nao emite nada): a galeria usa isso para voltar ao packshot do tom.
          // Lido antes de marcar o radio, para repetido e selected refletirem o estado do toque.
          // So o clique no label emite: o click sintetico no radio (e o do teclado) fica de fora.
          if (!ev || ev.target !== input) {
            this.dispatchEvent(new CustomEvent('pdp-offer:swatch-clicked', {
              bubbles: true,
              detail: {
                variantId: Number(sw.dataset.variantId),
                repetido: sw.classList.contains('swatch--selected'),
                selected: this.snapshotSelected(),
              },
            }));
          }
          if (!input.checked) input.checked = true;
          this.onSwatch(sw);
        }.bind(this), { signal: signal });
        input.addEventListener('change', this.onSwatch.bind(this, sw), { signal: signal });
      }, this);
    }

    getCheckedTier() {
      const checked = this.querySelector('input[name="pdp-tier"]:checked');
      return checked ? checked.closest('.pdp-offer__tier') : null;
    }

    onTierChange() {
      const tier = this.getCheckedTier();
      const qtd = tier ? parseInt(tier.dataset.quantidade, 10) || 1 : 1;
      // selected: o mesmo snapshot do variant-changed. Quem acompanha o tom da
      // 1a unidade (nota de preco, antes e depois, rotina) volta ao tom do
      // degrau que acabou de ser marcado, nao fica no do degrau anterior.
      this.dispatchEvent(new CustomEvent('pdp-offer:tier-changed', {
        bubbles: true, detail: { quantidade: qtd, selected: this.snapshotSelected() },
      }));
      this.computeAll();
      this.updateState();
    }

    onSwatch(sw) {
      if (sw.classList.contains('swatch--disabled')) return;
      // ja selecionado: no-op (dedup quando click E change disparam no mesmo swatch)
      if (sw.classList.contains('swatch--selected')) return;
      const input = sw.querySelector('input[type="radio"]');
      if (!input || input.disabled) return;
      if (!input.checked) input.checked = true;

      const group = input.name;
      this.querySelectorAll('.swatch input[name="' + cssEscape(group) + '"]').forEach(function (r) {
        const lbl = r.closest('.swatch');
        if (lbl) lbl.classList.toggle('swatch--selected', r.checked);
      });

      const optionValue = sw.dataset.optionValue || '';
      const unit = sw.closest('.pdp-offer__unit');
      this.descreveCor(unit ? unit.querySelector('[data-unit-desc]') : this.querySelector('[data-unit-desc]'), Number(sw.dataset.variantId));
      if (unit) {
        const tomEl = unit.querySelector('[data-unit-tom]');
        // O "· " separa o tom do ordinal ("1a unidade · #100"). Em tier de UMA
        // unidade o ordinal nao existe (o Liquid marca data-sem-prefixo), entao
        // o separador viraria um ponto solto no comeco da linha.
        if (tomEl) tomEl.textContent = (tomEl.hasAttribute('data-sem-prefixo') ? '' : '· ') + optionValue;
      } else {
        const tomEl = this.querySelector('.pdp-offer__lblsec [data-unit-tom]');
        if (tomEl) tomEl.textContent = optionValue;
      }

      this.dispatchEvent(new CustomEvent('pdp-offer:variant-changed', {
        bubbles: true,
        detail: { variantId: Number(sw.dataset.variantId), selected: this.snapshotSelected() },
      }));
      this.computeAll();
      this.updateState();
    }

    // Descricao da cor escolhida sob a bolinha: escreve o texto no <p data-unit-desc> e tira o hidden; sem texto
    // (ou sem o paragrafo, como na Base), volta a hidden. Sem aria-live: o texto acompanha a escolha, nao a anuncia.
    descreveCor(el, variantId) {
      if (!el) return;
      const texto = (this.corDesc && this.corDesc[variantId]) || '';
      el.textContent = texto;
      el.hidden = !texto;
    }

    /* ---------- leitura de selecao ---------- */

    // Variant ids escolhidos por unidade do tier (modo cards). Array de tamanho
    // qtd; posicao i = variantId escolhido na unidade i+1, ou null.
    unitsForTier(tierEl) {
      const qtd = parseInt(tierEl.dataset.quantidade, 10) || 1;
      const out = [];
      if (!this.hasVariant) {
        for (let i = 0; i < qtd; i++) out.push(this.defaultVariantId);
        return out;
      }
      const units = tierEl.querySelectorAll('.pdp-offer__unit');
      for (let i = 0; i < qtd; i++) {
        const unit = units[i];
        let id = null;
        if (unit) {
          const checked = unit.querySelector('.swatch input[type="radio"]:checked');
          if (checked) {
            const lbl = checked.closest('.swatch');
            if (lbl) id = Number(lbl.dataset.variantId);
          }
        }
        out.push(id);
      }
      return out;
    }

    directSelection() {
      if (!this.hasVariant) return this.defaultVariantId;
      const checked = this.querySelector('.pdp-offer__swatches .swatch input[type="radio"]:checked');
      if (!checked) return null;
      const lbl = checked.closest('.swatch');
      return lbl ? Number(lbl.dataset.variantId) : null;
    }

    snapshotSelected() {
      if (this.mode === 'direct') return { direct: this.directSelection(), qty: this.qty };
      const tier = this.getCheckedTier();
      return tier ? { tier: tier.dataset.tier, units: this.unitsForTier(tier) } : {};
    }

    /* ---------- degrau com kit (PDPs VIP, spec 2026-10-23) ---------- */

    // Objeto do degrau no JSON data-pdp-tiers, pela posição do card (data-tier é 1-based).
    tierData(tierEl) {
      return this.tiers[(parseInt(tierEl.dataset.tier, 10) || 1) - 1] || null;
    }

    // Kit do degrau. O JSON é a fonte de verdade; chave ausente (oferta de hoje,
    // fora da VIP) vale como sem kit, igual ao "kit":null.
    kitFor(tierEl) {
      const t = this.tierData(tierEl);
      return t && t.kit ? t.kit : null;
    }

    /*
     * Variante do kit casada pelo tom de cada posição: valores[i] do kit contra o
     * título da variante escolhida na unidade i+1 (o título da variante da Base é
     * o próprio tom, ex. "#100 Avelã"). Posição sem tom aceita qualquer valor.
     * Kit sem opção (variante única) casa direto. Completo = toda posição com tom;
     * aí a variante é a única candidata, ou null se o kit não tem a combinação.
     * Incompleto: o teto entre as candidatas disponíveis (regra da rotina), com a
     * primeira candidata de último recurso. `exibida` é a variante cujo preço e
     * "de" o card mostra: a casada, ou a do teto. Sem candidata nenhuma (tom que o
     * kit não tem), o teto sai do kit inteiro, para o card nunca cair na soma dos
     * avulsos.
     */
    kitVariantFor(tierEl) {
      const kit = this.kitFor(tierEl);
      if (!kit) return { variante: null, completo: false, teto: null, exibida: null };
      const n = (kit.opcoes || []).length;
      const todas = kit.variantes || [];
      const tons = this.unitsForTier(tierEl).map(function (id) {
        const v = id ? this.variantById[id] : null;
        return v ? String(v.title).trim() : null;
      }, this);
      const candidatas = todas.filter(function (v) {
        const valores = v.valores || [];
        for (let i = 0; i < n; i++) {
          if (tons[i] != null && String(valores[i]).trim() !== tons[i]) return false;
        }
        return true;
      });
      let completo = true;
      for (let i = 0; i < n; i++) if (tons[i] == null) completo = false;
      if (completo && candidatas.length) {
        return { variante: candidatas[0], completo: true, teto: null, exibida: candidatas[0] };
      }
      const base = candidatas.length ? candidatas : todas;
      let exibida = null;
      base.forEach(function (v) {
        if (v.disponivel && (!exibida || v.preco > exibida.preco)) exibida = v;
      });
      if (!exibida) exibida = base[0] || null;
      return { variante: null, completo: completo, teto: exibida ? exibida.preco : null, exibida: exibida };
    }

    /*
     * Degrau marcado sem caminho de compra: produto kit-vip com degrau de 2+ sem
     * kit válido (data-tier-indisponivel, nunca as N linhas do avulso), todos os
     * tons escolhidos numa combinação que o kit não tem, ou a variante do kit
     * casada esgotada (trava como a rotina, spec 4.2).
     */
    tierBloqueado() {
      if (this.mode !== 'cards') return false;
      const tier = this.getCheckedTier();
      if (!tier) return false;
      if (tier.dataset.tierIndisponivel === '1') return true;
      if (!this.kitFor(tier)) return false;
      const k = this.kitVariantFor(tier);
      if (k.variante) return !k.variante.disponivel;
      return k.completo;
    }

    /* ---------- derivacao de preco (bifurcada) ---------- */

    // Preco de um tier. cheio = soma das unidades (variantes reais quando todas
    // escolhidas, senao baseline product.price). economia = desconto pct sobre as
    // `unidades_com_desconto` unidades de MENOR valor, Math.round POR LINHA
    // (casa com o BxGy do Shopify). final = cheio - economia.
    tierPrice(tierEl) {
      const qtd = parseInt(tierEl.dataset.quantidade, 10) || 1;
      const pct = parseFloat(tierEl.dataset.descontoPct) || 0;
      const uni = parseInt(tierEl.dataset.unidadesDesconto, 10) || 0;

      if (this.designMode && pct > 0 && pct <= 1) {
        console.warn('[pdp-offer] desconto_percentual <= 1 (' + pct + '): cadastrado como 0.5 em vez de 50?');
      }

      // Degrau com kit: o preço é o da variante do kit, nunca desconto sobre os
      // avulsos. O "de" é o compare_at dela quando MAIOR que o preço (mesma regra
      // do unitCompare); sem compare_at, sem riscado.
      if (this.kitFor(tierEl)) {
        const v = this.kitVariantFor(tierEl).exibida;
        if (!v) {
          const cheio = this.productPrice * qtd;
          return { cheio: cheio, economia: 0, final: cheio, kit: true };
        }
        const de = v.compare > v.preco ? v.compare : v.preco;
        return { cheio: de, economia: de - v.preco, final: v.preco, kit: true };
      }

      let prices = null;
      if (this.hasVariant) {
        const units = this.unitsForTier(tierEl);
        if (units.length === qtd && units.every(Boolean)) {
          prices = units.map(function (id) {
            const v = this.variantById[id];
            return v ? v.price : this.productPrice;
          }, this);
        }
      }
      if (!prices) {
        prices = [];
        for (let i = 0; i < qtd; i++) prices.push(this.productPrice);
      }

      return this.priceFrom(prices, pct, uni);
    }

    // Aplica o desconto sobre as `uni` unidades de MENOR valor, Math.round POR
    // LINHA (casa com o BxGy do Shopify). Reusado por cards e modo direto.
    priceFrom(prices, pct, uni) {
      const cheio = prices.reduce(function (a, b) { return a + b; }, 0);
      const sorted = prices.slice().sort(function (a, b) { return a - b; });
      let economia = 0;
      const n = Math.min(uni, prices.length);
      for (let i = 0; i < n; i++) {
        if (pct > 0) economia += Math.round(sorted[i] * pct / 100);
      }
      return { cheio: cheio, economia: economia, final: cheio - economia };
    }

    // Preenche os slots de/por/economia de todos os tiers.
    computeAll() {
      if (this.mode === 'cards') {
        this.querySelectorAll('.pdp-offer__tier').forEach(function (tierEl) {
          const p = this.tierPrice(tierEl);
          this.setText(tierEl.querySelector('[data-tier-now]'), money(p.final));
          this.toggleSlot(tierEl.querySelector('[data-tier-compare]'), p.economia > 0, money(p.cheio));
          this.toggleSlot(tierEl.querySelector('[data-tier-econ]'), p.economia > 0, 'ECONOMIZE ' + money(p.economia));
          // "R$ 119,90 cada": só com mostrar_preco_unitario no JSON do degrau.
          const t = this.tierData(tierEl);
          const qtd = parseInt(tierEl.dataset.quantidade, 10) || 1;
          this.toggleSlot(
            tierEl.querySelector('[data-tier-cada]'),
            !!(t && t.mostrar_preco_unitario === true),
            money(Math.round(p.final / qtd)) + ' cada'
          );
        }, this);
      }
      this.updateSummary();
    }

    updateSummary() {
      if (!this.summaryEl) return;
      let p;
      if (this.mode === 'cards') {
        const tier = this.getCheckedTier();
        p = tier ? this.tierPrice(tier) : null;
      } else {
        // modo direto: 1 tier; aplica desconto do tier[0] se houver (robusto a
        // um single-tier com oferta, nao assume economia 0).
        const tier0 = this.tiers[0] || {};
        const pct = parseFloat(tier0.desconto_percentual) || 0;
        const uni = parseInt(tier0.unidades_com_desconto, 10) || 0;
        const unitPrice = this.directUnitPrice();
        const prices = [];
        for (let i = 0; i < this.qty; i++) prices.push(unitPrice);
        p = this.priceFrom(prices, pct, uni);
      }
      if (!p) {
        if (this.totalEl) this.totalEl.textContent = '';
        if (this.econEl) { this.econEl.hidden = true; this.econEl.textContent = ''; }
        if (this.notaEl) this.notaEl.hidden = true;
        if (this.pixEl) this.pixEl.hidden = true;
        return;
      }
      if (this.totalEl) this.totalEl.textContent = money(p.final);

      /*
       * Linha do PIX (calendario de campanhas, aviso com pix_percentual). Calcula
       * sobre o total que a cliente esta vendo, entao acompanha o degrau. Mesma
       * conta do snippet biobio-pix-preco (final - arredonda(final x pct)), para
       * as duas PDPs nunca divergirem em 1 centavo. O guarda de vencimento
       * (biobio-campanhas.js) esconde a linha no fim do aviso com display none,
       * que vence o hidden=false daqui.
       */
      if (this.pixEl) {
        const pct = parseFloat(this.pixEl.getAttribute('data-pix-pct')) || 0;
        if (pct > 0 && p.final > 0 && this.pixValorEl) {
          this.pixValorEl.textContent = money(p.final - Math.round(p.final * pct / 100));
          this.pixEl.hidden = false;
        } else {
          this.pixEl.hidden = true;
        }
      }

      /*
       * A observacao ("Nao cumulativo...") so aparece quando o degrau escolhido
       * TEM desconto de oferta. No degrau de 1 unidade nao ha promocao, entao a
       * ressalva confunde: fala de uma condicao que nao esta valendo.
       * Condicao e `p.economia`, o desconto da OFERTA, e nao a economia exibida
       * mais abaixo, que e `de - final` e fica positiva tambem quando o tom tem
       * desconto proprio de variante. Usar a de baixo faria a nota surgir num
       * tom em promocao sem oferta nenhuma selecionada.
       */
      if (this.notaEl) this.notaEl.hidden = !(p.economia > 0);

      /*
       * de/por + economia. O "de" vem do compare_at (compareBaseline), NAO do
       * `p.cheio`: `p.cheio` e a soma dos precos ja praticados, entao num tom
       * com desconto de variante ele seria igual ao final e nao haveria riscado.
       * A economia passa a ser `de - final`, ou seja, o total que a cliente
       * deixa de pagar somando desconto de tom + desconto de oferta.
       */
      const de = this.compareBaseline();
      const economia = de > p.final ? de - p.final : 0;

      if (this.compareEl) {
        this.compareEl.textContent = economia > 0 ? money(de) : '';
        this.compareEl.hidden = economia <= 0;
      }
      if (this.econEl) {
        if (economia > 0) {
          this.econEl.textContent = 'Você economiza ' + money(economia);
          this.econEl.hidden = false;
        } else {
          this.econEl.hidden = true;
          this.econEl.textContent = '';
        }
      }
    }

    directUnitPrice() {
      const id = this.directSelection();
      const v = id ? this.variantById[id] : null;
      return v ? v.price : this.productPrice;
    }

    /*
     * "De" de UMA unidade: compare_at da variante quando ele e MAIOR que o
     * preco, senao o proprio preco. O `>` importa: no catalogo BioBio existe
     * variante com compare_at IGUAL ao preco (a Base tem 139,90/139,90 nos 6
     * tons sem promocao), e tratar isso como desconto renderizaria um riscado
     * com o mesmo numero dos dois lados.
     */
    unitCompare(id) {
      const v = id ? this.variantById[id] : null;
      if (v) {
        const c = parseInt(v.compare_at_price, 10) || 0;
        return c > v.price ? c : v.price;
      }
      return this.productCompare > this.productPrice ? this.productCompare : this.productPrice;
    }

    /*
     * "De" do pedido inteiro. Soma o compare_at por unidade, nos dois modos.
     * Com isso o par de/por cobre as DUAS fontes de desconto de uma vez: a da
     * VARIANTE (tom em promocao, via compare_at) e a da OFERTA (tier). Antes o
     * resumo so enxergava a do tier, entao um tom a 40% aparecia sem riscado.
     */
    compareBaseline() {
      if (this.mode === 'direct') {
        return this.unitCompare(this.directSelection()) * this.qty;
      }
      const tier = this.getCheckedTier();
      if (!tier) return 0;
      // Degrau com kit: o "de" é o da variante do kit, nunca a soma dos avulsos.
      if (this.kitFor(tier)) return this.tierPrice(tier).cheio;
      const qtd = parseInt(tier.dataset.quantidade, 10) || 1;
      const units = this.unitsForTier(tier);
      let soma = 0;
      for (let i = 0; i < qtd; i++) soma += this.unitCompare(units[i]);
      return soma;
    }

    /* ---------- estado do CTA + add-to-cart ---------- */

    isComplete() {
      if (this.mode === 'direct') {
        return this.hasVariant ? this.directSelection() != null : true;
      }
      const tier = this.getCheckedTier();
      if (!tier) return false;
      if (tier.dataset.tierIndisponivel === '1') return false;
      if (this.kitFor(tier)) return this.kitVariantFor(tier).completo;
      if (!this.hasVariant) return true;
      return this.unitsForTier(tier).every(Boolean);
    }

    selectedVariantIds() {
      if (this.mode === 'direct') {
        const id = this.directSelection();
        const ids = [];
        for (let i = 0; i < this.qty; i++) ids.push(id);
        return ids;
      }
      const tier = this.getCheckedTier();
      return tier ? this.unitsForTier(tier) : [];
    }

    isAvailable() {
      if (this.mode === 'cards') {
        const tier = this.getCheckedTier();
        if (tier && tier.dataset.tierIndisponivel === '1') return false;
        if (tier && this.kitFor(tier)) {
          // Estoque da variante do kit (derivado do componente). Sem todos os
          // tons ainda não há o que conferir; completo sem variante = combinação
          // que o kit não tem.
          const k = this.kitVariantFor(tier);
          if (k.variante) return !!k.variante.disponivel;
          return !k.completo;
        }
      }
      return this.selectedVariantIds().every(function (id) {
        if (id == null) return true;
        const v = this.variantById[id];
        return !v || v.available;
      }, this);
    }

    // N line items SEPARADOS: 1 por unidade, com property _unidade UNICA (o
    // /cart/add.js funde itens de mesmo id sem properties distintas; o ERP exige
    // linhas separadas).
    buildItems() {
      if (this.mode === 'cards') {
        const tier = this.getCheckedTier();
        if (tier && tier.dataset.tierIndisponivel === '1') return [];
        // Degrau com kit: UMA linha, a variante do kit, com _oferta = quantidade
        // (conta os pedidos vindos da oferta). Sem variante casada, nada.
        if (tier && this.kitFor(tier)) {
          const k = this.kitVariantFor(tier);
          if (!k.variante) return [];
          return [{ id: k.variante.id, quantity: 1, properties: { _oferta: parseInt(tier.dataset.quantidade, 10) || 1 } }];
        }
      }
      const ids = this.selectedVariantIds();
      const items = [];
      ids.forEach(function (id, i) {
        if (id == null) return;
        items.push({ id: id, quantity: 1, properties: { _unidade: i + 1 } });
      });
      return items;
    }

    setCtaLocked(locked) {
      if (!this.addBtn) return;
      this.addBtn.disabled = !!locked;
      this.addBtn.classList.toggle('pdp-offer__button--locked', !!locked);
    }
    setCtaIncomplete() {
      this.setCtaLocked(true);
      if (this.addBtn && this.addBtn.dataset.textIncomplete) {
        this.addBtn.textContent = this.addBtn.dataset.textIncomplete;
      }
    }
    setCtaIndisponivel() {
      this.setCtaLocked(true);
      if (this.addBtn) this.addBtn.textContent = TEXTO_INDISPONIVEL;
    }
    setCtaReady(available) {
      this.setCtaLocked(!available);
      if (this.addBtn && this.addBtn.dataset.textAdd) {
        this.addBtn.textContent = this.addBtn.dataset.textAdd;
      }
    }

    updateState() {
      /*
       * Degrau sem caminho de compra (tierBloqueado): trava com a copy da rotina
       * e sem avise-me, que miraria as variantes do produto da página e não o
       * kit. Vem antes do teste de tom porque vale também em produto sem
       * variante (Pó, Protetor), onde aquele teste nem roda, e no degrau que
       * nasce marcado.
       */
      if (this.tierBloqueado()) {
        this.setCtaIndisponivel();
        if (this.unavailableEl) this.unavailableEl.hidden = true;
        this.toggleAvise(false);
        return;
      }
      // tom obrigatorio so quando ha variante; sem variante, completo por padrao.
      if (this.hasVariant && !this.isComplete()) {
        this.setCtaIncomplete();
        if (this.unavailableEl) this.unavailableEl.hidden = true;
        this.toggleAvise(false);
        return;
      }
      if (!this.isAvailable()) {
        this.setCtaReady(false);
        if (this.unavailableEl) {
          this.unavailableEl.textContent = this.unavailableText;
          this.unavailableEl.hidden = false;
        }
        this.toggleAvise(true);
        return;
      }
      if (this.unavailableEl) this.unavailableEl.hidden = true;
      this.toggleAvise(false);
      this.setCtaReady(true);
    }

    /*
     * "Avise-me quando voltar" (04/08). Aparece NO LUGAR do CTA quando a
     * combinacao escolhida esta esgotada e some quando ela volta. Esconder o
     * `.pdp-offer__form` inteiro leva junto o stepper de quantidade, que nao faz
     * sentido num produto que nao da pra comprar.
     */
    toggleAvise(mostrar) {
      if (!this.aviseEl) return;
      this.aviseEl.hidden = !mostrar;
      if (this.form) this.form.hidden = mostrar;
      // O stepper vive FORA do form; escondido junto porque escolher quantidade
      // de um produto que nao da pra comprar nao faz sentido.
      if (this.stepperEl) this.stepperEl.hidden = mostrar;
      // Trocou pra um tom disponivel com o modal aberto: fecha, senao a cliente
      // pediria aviso de um tom que ela acabou de sair.
      if (!mostrar && this.aviseDialog && this.aviseDialog.open) this.aviseDialog.close();
    }

    /*
     * Abre o modal ja apontando pro tom escolhido, no texto e na tag. Tudo e
     * resolvido AQUI (e nao na selecao) porque so o que esta na tela no momento
     * do envio importa.
     */
    abrirAvise() {
      if (!this.aviseDialog) return;
      this.syncAviseTags();
      if (this.aviseAlvoEl) {
        const alvo = this.unavailableVariantId();
        const v = alvo ? this.variantById[alvo] : null;
        this.aviseAlvoEl.textContent = v && this.hasVariant
          ? this.aviseProdutoNome + ' ' + v.title
          : this.aviseProdutoNome;
      }
      if (typeof this.aviseDialog.showModal === 'function') this.aviseDialog.showModal();
      else this.aviseDialog.setAttribute('open', '');
      const campo = this.aviseDialog.querySelector('input[type="email"]');
      if (campo) campo.focus();
    }

    /*
     * A tag por TOM e o que torna o aviso util: e ela que diz quem avisar de que.
     * Os dois termos fixos (geral e por produto) vem do SSR e sao preservados;
     * so o termo do tom e reescrito a cada selecao. Sem slug conhecido (produto
     * de variante unica), fica so nos dois fixos.
     */
    syncAviseTags() {
      if (!this.aviseTagsEl) return;
      // Produto de variante unica nao tem termo de tom: sem o guard, o JS
      // re-anexava o "-default-title" que o SSR ja evita (visto no admin 04/08).
      const alvo = this.hasVariant ? this.unavailableVariantId() : null;
      const slug = alvo ? this.aviseSlugs[alvo] : null;
      this.aviseTagsEl.value = slug
        ? this.aviseTagsBase + ', avise-me-' + this.dataset.productHandle + '-' + slug
        : this.aviseTagsBase;
    }

    /*
     * Tudo que precisa acontecer ANTES do POST nativo sair, num lugar so.
     * A marca de sessao e o discriminador da volta: form.posted_successfully? e
     * GLOBAL por tipo de form, entao a newsletter do RODAPE desta mesma pagina
     * tambem volta com customer_posted=true; sem a marca o modal abriria
     * dizendo "a gente te avisa" pra quem so assinou newsletter.
     */
    prepararEnvioAvise() {
      this.syncAviseTags();
      try {
        sessionStorage.setItem('bb-avise-pendente', this.dataset.productHandle || '1');
      } catch (err) { /* sem sessionStorage o gate abre sozinho, sem quebrar */ }
    }

    unavailableVariantId() {
      const ids = this.selectedVariantIds();
      for (let i = 0; i < ids.length; i++) {
        const v = ids[i] == null ? null : this.variantById[ids[i]];
        if (v && !v.available) return v.id;
      }
      return null;
    }

    // CRITERIO DURO: add real via /cart/add.js + drawer. Nunca submit nativo nem Yampi.
    handleSubmit(event) {
      if (event) event.preventDefault();
      if (!this.addBtn || this.addBtn.disabled) return;
      if (this.classList.contains('pdp-offer--adding')) return; // anti duplo-clique

      const items = this.buildItems();
      if (!items.length) return;

      this.classList.add('pdp-offer--adding');
      this.addBtn.disabled = true; // trava por atributo tambem (belt-and-suspenders)
      this.addBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) return res.json().catch(function () { return {}; }).then(function (d) {
            throw new Error(d.description || 'HTTP ' + res.status);
          });
          return res.json();
        })
        .then(function () {
          // item JA adicionado; abrir o drawer. Se updateCartSummaries lancar,
          // cai pro /cart (NUNCA pro Yampi) e NAO vira erro de add enganoso.
          const t = window.theme;
          const cartPageMode = !!(t && t.settings && t.settings.cartType === 'page');
          if (t && typeof t.updateCartSummaries === 'function' && !cartPageMode) {
            try {
              t.updateCartSummaries(true, true, false);
            } catch (e) {
              console.warn('[pdp-offer] updateCartSummaries falhou; indo pro /cart', e);
              window.location.href = '/cart';
            }
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('[pdp-offer] add-to-cart falhou', err);
          if (this.unavailableEl) {
            this.unavailableEl.textContent = 'Erro ao adicionar ao carrinho. Tente novamente.';
            this.unavailableEl.hidden = false;
          }
        }.bind(this))
        .then(function () {
          this.classList.remove('pdp-offer--adding');
          if (this.addBtn) this.addBtn.removeAttribute('aria-busy');
          this.updateState(); // restaura o disabled conforme isComplete/isAvailable
        }.bind(this));
    }

    /* ---------- integracao tone-finder ---------- */
    onToneResolved(event) {
      // Finder em modo aplicar (gaveta "Me ajuda a escolher"): o resolved sai
      // sozinho a cada resposta do quiz, e marcar o swatch aqui trocaria o tom
      // de quem so estava olhando. Ali so o tone-finder:applied ("Usar este
      // tom") aplica. Fora da gaveta (biobio_pdp_tom do pdp-master), como antes.
      const alvo = event && event.target;
      if (alvo && alvo.closest && alvo.closest('[data-result-mode="apply"]')) return;
      const ids = event && event.detail && event.detail.variantIds;
      if (!ids || !ids.length) return;
      const variantId = ids[0];
      if (!this.variantById[variantId]) return; // tom de outro produto

      let scope;
      if (this.mode === 'cards') {
        const tier = this.getCheckedTier();
        if (!tier) return;
        const firstUnit = tier.querySelector('.pdp-offer__unit');
        scope = firstUnit || tier;
      } else {
        scope = this.querySelector('.pdp-offer__swatches');
      }
      if (!scope) return;
      const target = scope.querySelector('.swatch[data-variant-id="' + variantId + '"]');
      if (target && !target.classList.contains('swatch--disabled')) {
        this.onSwatch(target);
      }
    }

    /* ---------- helpers ---------- */
    setText(el, txt) { if (el) el.textContent = txt; }
    toggleSlot(el, show, txt) {
      if (!el) return;
      el.hidden = !show;
      if (show) el.textContent = txt;
    }
  }

  customElements.define('pdp-offer', PdpOffer);

  /* -------------------------------------------------------------------------
   * Fallback de add-to-cart pra page template (belt-and-suspenders).
   * O form e PLAIN e o botao e type=button, entao submit nativo praticamente
   * nao ocorre; mas se um submit escapar, garantimos o criterio duro aqui:
   * /cart/add.js com os N items do componente, nunca o Yampi.
   * ----------------------------------------------------------------------- */
  if (!window.__biobioPdpOfferCartBound) {
    window.__biobioPdpOfferCartBound = true;
    document.addEventListener('submit', function (event) {
      const form = event.target;
      if (!form || !form.classList || !form.classList.contains('pdp-offer__form')) return;
      event.preventDefault();
      const host = form.closest('pdp-offer');
      if (!host || typeof host.handleSubmit !== 'function') return;
      host.handleSubmit(event);
    }, false);
  }
})();
